import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {tap} from 'rxjs/operators';
import { AppConstants } from '../AppConstants';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private router: Router, private authService: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.authService.restorePersistentLogin();
        //const accessToken = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_ACCESS_TOKEN));
        const accessToken = this.getAccessToken();
        if(accessToken) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
        }
        return next.handle(request).pipe( tap(() => {},
        (error: HttpErrorResponse) => {
            console.log(error);
            if (error.status !== 401) {
                return;
            }
            if(error.status == 401 && error.error?.errors?.[0]?.message == 'Invalid Username Or Password.') {
                return;
            }
            alert("Session Expired");
            this.authService.clearLogin();
            this.clearAuthStorage();
            this.router.navigateByUrl('').then(() => {
            window.location.reload();
            });
        }));
    }

    private getAccessToken(): string | null {
        const storedToken = this.getStoredItem(AppConstants.SESSION_STORAGE_ACCESS_TOKEN);

        if (!storedToken) {
            return null;
        }

        try {
            return JSON.parse(storedToken);
        } catch (error) {
            return storedToken;
        }
    }

    private getStoredItem(key: string): string | null {
        try {
            return sessionStorage.getItem(key) || localStorage.getItem(key);
        } catch (error) {
            try {
                return localStorage.getItem(key);
            } catch (fallbackError) {
                return null;
            }
        }
    }

    private clearAuthStorage() {
        [
            AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT,
            AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT,
            AppConstants.SESSION_STORAGE_ACCESS_TOKEN,
            AppConstants.SESSION_STORAGE_PAYMENT_SOURCE,
            'selected-tenant-id',
            'postLoginUrl'
        ].forEach(key => {
            try {
                sessionStorage.removeItem(key);
            } catch (error) {}

            try {
                localStorage.removeItem(key);
            } catch (error) {}
        });
    }
}
